import React, { useEffect, useState } from "react";
import {
    Card,
    Input,
    Select,
    Button,
    DatePicker,
    Steps,
    Table,
    Space,
    Row,
    Col,
    Form,
    Divider,
    message,
    Upload,
    InputNumber,
    Collapse,
    Typography,
} from "antd";
import { UploadOutlined, EditOutlined, CloudDownloadOutlined, DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import { FormInstance } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { createAyushBClaim, postAyushBClaim, updateAyushBClaim } from "../../../../apis/ayushmanBService";
import { errorMessage } from "../../../../utils/notificationUtils";
import { errorMessageModal } from "../../../../utils/modalMessage";
const { Panel } = Collapse;
const { Option } = Select;
const { Step } = Steps;
const { Text } = Typography;

// Interfaces
interface TabType {
    id: number;
    label: string;
    value: string;
}

interface FinanceRecordType {
    no: string;
    packageCode: string;
    packageType: string;
    procedureCost: string;
    stratificationCost: string;
    quantity: string;
    packageCost: string;
    adjFactor: string;
    incentives: string;
    total: string;
}

interface FinanceQuantityRecordType {
    key: string;
    no: string;
    packageCode: string;
    approvedQuantity: string;
    requestedQuantity: string;
    packageCost: string;
    adjFactor: string;
    incentives: string;
    total: string;
    remark: string;
}

interface UploadedFileType {
    key: string;
    documentType: string;
    document: string;
    deficiency: string;
    deficiencyType: string;
}

interface TotalAmountDetailsProps {
    totalPackageAmount?: string;
    adjustedPackageAmount?: string;
    totalPayableAmount?: string;
    eRupiAmount?: string;
    miscAmount?: string;
  }

interface AyushB {
    activeStep: number;
    handleNext: () => void;
    handlePrevious: () => void;
    handleGetData: () => void;
    handleModalOpen: () => void;
    form: FormInstance<any>;
    // setDocumentType: any;
    // documentType: any;
    setActiveDocListType: any;
    activeDocListType: string;
    setUploadedHospitalFileList: any;
    setUploadedOtherFileList: any;
    uploadedHospitalFileList: any;
    uploadedOtherFileList: any;
    handleUploadFile: any;
    uploadedFileColumns: any;
    stageStatus: number | null;
    portalMetaDataId: any
    documentOptions: any;
}

// Mock Data
const FinanceRecord: FinanceRecordType[] = [
    {
        no: "1",
        packageCode: "PCKG123",
        packageType: "Standard",
        procedureCost: "$500",
        stratificationCost: "$100",
        quantity: "2",
        packageCost: "$1200",
        adjFactor: "1.2",
        incentives: "$50",
        total: "$1450",
    },
];

const FinanceQuantityRecord: FinanceQuantityRecordType[] = [
    {
        key: "1",
        no: "001",
        packageCode: "PKG123",
        approvedQuantity: "1000",
        requestedQuantity: "800",
        packageCost: "1500",
        adjFactor: "1.2",
        incentives: "50",
        total: "1800",
        remark: "Approved for full quantity",
    },
];

const uploadedFiles: UploadedFileType[] = [
    {
        key: "1",
        documentType: "CPAS Card",
        document: "chboard123.pdf",
        deficiency: "Check Deficiency",
        deficiencyType: "default",
    },
];

// Table Columns
const FinanceColumns = [
    {
        title: "No.",
        dataIndex: "no",
        key: "no",
        render: (_: string, r_: any, index: number) => <span style={{ fontWeight: "bold" }}>{(index + 1)}</span>,
    },
    {
        title: "Package Code",
        dataIndex: "procedureCode",
        key: "procedureCode",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Package Type",
        dataIndex: "packageType",
        key: "packageType",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Procedure Cost",
        dataIndex: "procedureCost",
        key: "procedureCost",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Stratification Cost",
        dataIndex: "stratificationCost",
        key: "stratificationCost",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Package Cost",
        dataIndex: "packageCost",
        key: "packageCost",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Adj Factor",
        dataIndex: "adjFactor",
        key: "adjFactor",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Incentives",
        dataIndex: "incentives",
        key: "incentives",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Total",
        dataIndex: "totalAmount",
        key: "totalAmount",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
];

const FinanceQuantityColumns = [
    {
        title: "No.",
        dataIndex: "no",
        key: "no",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Package Code",
        dataIndex: "packageCode",
        key: "packageCode",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Approved Quantity",
        dataIndex: "approvedQuantity",
        key: "approvedQuantity",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Requested Quantity",
        dataIndex: "requestedQuantity",
        key: "requestedQuantity",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Package Cost",
        dataIndex: "packageCost",
        key: "packageCost",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Adj Factor",
        dataIndex: "adjFactor",
        key: "adjFactor",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Incentives",
        dataIndex: "incentives",
        key: "incentives",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Total Amount",
        dataIndex: "total",
        key: "total",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
        title: "Remarks",
        dataIndex: "remark",
        key: "remark",
        render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
];

const styles: Record<string, React.CSSProperties> = {
    mainContent: {
        minHeight: "64px",
        background: "rgb(243, 243, 243)",
        padding: "12px 25px", // Removed the semicolon and fixed the gap
        gap: "42px", // Added the gap as a separate property
        borderRadius: "16px 16px 0px 0px", // Fixed camelCase
        borderBottom: "1px solid rgb(166, 166, 166)",
        fontWeight: "600",
        fontSize: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    statusDesign: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "20px",
        minWidth: "676px",
        maxHeight: "36px",
    },
    editAndSaveButtonDesign: {
        float: "right",
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        zIndex: 1000,
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        padding: "10px 0",
        margin: "0px 55px"
    },
    continueButton: {
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
    },
    saveEditButton: {
        color: "white",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
    },
    editButton: {
        color: "#008B8B",
        background: "white",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
    },
    previousButton: {
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
        marginRight: "10px",
    },
    submitButton: {
        marginRight: "10px",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
    },
};

const dateFormat = "DD-MM-YYYY HH:mm:ss";

const parseDateSafely = (dateString: string) => {
    if (!dateString) return "";

    // Try to parse the date
    const parsed = dayjs(dateString, dateFormat);
    // For DD-MM-YYYY HH:mm:ss format which might not be recognized automatically
    if (!parsed.isValid()) {
        return dayjs(dateString, "DD-MM-YYYY HH:mm:ss");
    }

    return parsed;
};

export const PreAuthClaimAyushB: React.FC<AyushB> = (props) => {
    const { patients, preAuthClaim, hospital, auth, ayushBPreAuth } = useSelector(
        (state: RootState) => state
    );
    // const [form] = Form.useForm();
    const [activeFinanceTab, setActiveFinanceTab] = useState<TabType>({ id: 0, label: "AMOUNT AND INCENTIVE DETAILS", value: "AMOUNT_INCENTIVE" });
    const [formData, setFormData] = useState({
        billAmount: "",
        billDate: "",
        billNumber: "",
    });
    const [disabledForm, setDisabledForm] = useState(false);
    const [packageFinanceData, setPackageFinanceData] = useState([]);
    const [totalAmountData, setTotalAmountData] = useState<TotalAmountDetailsProps | null>(null);

    const financeTabs: TabType[] = [
        { id: 0, label: "AMOUNT AND INCENTIVE DETAILS", value: "AMOUNT_INCENTIVE" },
        { id: 1, label: "HOSPITAL BILL DETAILS", value: "HOSPITAL_BILL_DETAILS" },
        { id: 2, label: "OTHERS", value: "OTHERS" },
    ];

    const mapApiResponseToState = (apiResponse: any) => ({
        billDate: apiResponse?.billDate ? parseDateSafely(apiResponse?.billDate) : null,
        billAmount: apiResponse?.billAmount,
        billNumber: apiResponse?.billNumber
    });

    const caseClaimId = ayushBPreAuth?.claim?.caseData ? ayushBPreAuth?.claim?.caseData?.id : null;

    useEffect(() => {
        caseClaimId && setDisabledForm(true)
    }, [caseClaimId])

    useEffect(() => {
        if (ayushBPreAuth?.claim?.financeDetails){
            const financeAmountDetails = ayushBPreAuth?.claim?.financeDetails?.finance?.amountDetails
            setPackageFinanceData(financeAmountDetails || []);

            const totalAmounts = {
                totalPackageAmount: financeAmountDetails?.totalPackageAmountWithoutIncentives,
                adjustedPackageAmount: financeAmountDetails?.totalAdjustedPackageAmountAsPerGuidelines,
                totalPayableAmount: financeAmountDetails?.totalPayableAmount,
                eRupiAmount: financeAmountDetails?.eRupiAmount,
                miscAmount: financeAmountDetails?.miscAmount
              }
            setTotalAmountData(totalAmounts || null)
        } 


    }, [ayushBPreAuth?.claim?.financeDetails])

    useEffect(() => {
        if (ayushBPreAuth?.claim?.caseData) {
            props?.form.setFieldsValue(mapApiResponseToState(ayushBPreAuth?.claim?.caseData?.hospitalBill));
        }
    }, [ayushBPreAuth?.claim?.caseData]);

    useEffect(() => {
        if (activeFinanceTab.id === 1) {
            props?.setActiveDocListType("hospital")
        }
        if (activeFinanceTab.id === 2) {
            props?.setActiveDocListType("others")
        }
    }, [activeFinanceTab])

    // const handleUploadFile = () => {
    //     if (!props?.documentType) {
    //         message.error("Please select a document type first!");
    //         return;
    //     }

    //     const newFile: UploadedFileType = {
    //         key: (props?.uploadedFileList.length + 1).toString(),
    //         documentType: props?.documentType,
    //         document: `Document_${Math.floor(Math.random() * 1000)}.pdf`,
    //         deficiency: "Check Deficiency",
    //         deficiencyType: "default",
    //     };

    //     props?.setUploadedFileList((prev: any) => [...prev, newFile]);
    //     message.success(`${newFile.document} uploaded successfully!`);
    //     props?.setDocumentType(null);
    // };

    const handleUpdateAsDraftToPortal = async () => {
        try {
            const formData = await props?.form.getFieldsValue(true);
            const formattedBillDate = formData.billDate
                ? dayjs(formData.billDate).format(dateFormat)
                : null;
            const data = {
                // financeData: FinanceRecord,
                hospitalBill: {
                    ...formData,
                    billDate: formattedBillDate
                },
                hospitalDocuments: props?.uploadedHospitalFileList,
                otherDocuments: props?.uploadedOtherFileList,
            };

            const payloadData = {
                params: {
                    caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                    visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                    caseClaimId: caseClaimId
                    ,
                },
                data: data
            }

            const res = await updateAyushBClaim(payloadData);
            res && message.success("Claim Updated Successfully!")
            setDisabledForm(true);
            props?.handleGetData();

        } catch (error: any) {
            const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
            errorMessageModal(errorMsg);
        }

    };

    const handleSaveAsDraftToPortal = async () => {
        try {
            const formData = await props?.form.getFieldsValue(true);
            const formattedBillDate = formData.billDate
                ? dayjs(formData.billDate).format(dateFormat)
                : null;
            const data = {
                // financeData: FinanceRecord,
                hospitalBill: {
                    ...formData,
                    billDate: formattedBillDate
                },
                hospitalDocuments: props?.uploadedHospitalFileList,
                otherDocuments: props?.uploadedOtherFileList,
            };

            const payloadData = {
                params: {
                    caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                    visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                    portalMetaDataId: props?.portalMetaDataId,
                },
                data: data
            }

            const res = await createAyushBClaim(payloadData);
            res && message.success("Claim Saved Successfully!")
            props?.handleGetData();

        } catch (error: any) {
            const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
            errorMessageModal(errorMsg);
        }

    };

    const handleSubmitToPortal = async () => {
        try {
            await props?.form.validateFields();

            const formData = await props?.form.getFieldsValue(true);
            const formattedBillDate = formData.billDate
                ? dayjs(formData.billDate).format(dateFormat)
                : null;
            const data = {
                // financeData: FinanceRecord,
                hospitalBill: {
                    ...formData,
                    billDate: formattedBillDate
                },
                hospitalDocuments: props?.uploadedHospitalFileList,
                otherDocuments: props?.uploadedOtherFileList,
            };


            const payloadData = {
                params: {
                    caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                    visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                    portalMetaDataId: props?.portalMetaDataId,
                },
                data: data
            }

            const res = await postAyushBClaim(payloadData);
            res && message.success("Claim Submitted Successfuly!")
            props?.handleGetData();

        } catch (error: any) {
            if (error?.errorFields?.length) {
                errorMessageModal("Please, fill all required fields!");
            } else {
                const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
                errorMessageModal(errorMsg);
            }
        }

    };

    // Handle form field changes
    const handleFieldChange = (field: any, value: any) => {
        setFormData({ ...formData, [field]: value });
    }

    const getTabButtonStyle = (isActive: boolean) => {
        return isActive
            ? {
                background: "#008B8B",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
                borderBottomLeftRadius: "0px",
                borderBottomRightRadius: "0px",
                fontWeight: "700",
                height: "35px",
                boxShadow: "0px -1px 4px 0px #00000040 inset",
                color: "#fff"
            }
            : {
                border: "none",
                boxShadow: "none",
                height: "35px",
                color: "#575757",
            };
    };

    const renderAmountIncentive = () => {
        return (
            <>
                <Card className="tableOfPreAuth" style={{ padding: "10px 0px" }}>
                    <Table
                        dataSource={packageFinanceData}
                        columns={FinanceColumns}
                        pagination={false}
                        bordered
                        style={{ width: "95%", margin: "10px auto", textAlign: "center", paddingBottom: "15px" }}
                    />
                    {
                        totalAmountData &&
                        <div
                            style={{ width: "95%", margin: "10px auto", textAlign: "center", paddingBottom: "15px", backgroundColor: "rgb(229, 243, 243)" }}
                        >
                            {totalAmountData?.totalPackageAmount && renderRow('Total package amount (without incentives)', totalAmountData?.totalPackageAmount)}
                            {totalAmountData?.adjustedPackageAmount && renderRow('Total adjusted package amount (as per guidelines)', totalAmountData?.adjustedPackageAmount)}
                            {totalAmountData?.totalPayableAmount && renderRow('Total payable amount (after incentives)', totalAmountData?.totalPayableAmount)}
                            {totalAmountData?.eRupiAmount && renderRow('e-RUPI Amount', totalAmountData?.eRupiAmount)}
                            {totalAmountData?.miscAmount && renderRow('Miscellaneous Amount', totalAmountData?.miscAmount)}
                        </div>
                    }

                    {/* <Table
                        dataSource={FinanceQuantityRecord}
                        columns={FinanceQuantityColumns}
                        pagination={false}
                        bordered
                        style={{ width: "95%", margin: "10px auto", textAlign: "center" }}
                    /> */}
                </Card>
            </>
        )
    }

    const renderRow = (label: string, value: string) => (
        <Row justify="space-between" style={{ marginBottom: 8 }}>
          <Col>
            <Text>{label}</Text>
          </Col>
          <Col>
            <Text strong>{value}</Text>
          </Col>
        </Row>
      );

    const renderHospitalForm = () => {
        return (
            <>
                <Collapse defaultActiveKey={[]}>
                    <Panel 
                        header="Hospital Bill Details" 
                        key="1"
                        style={{ backgroundColor: "rgb(229, 243, 243)" }}
                    >
                        <Form
                            form={props?.form}
                            layout="vertical"
                            disabled={disabledForm}
                            style={{ padding: "15px 0" }}
                        >
                            <Row gutter={20}>
                                <Col span={8}>
                                    <Form.Item
                                        label="Hospital Bill Number"
                                        name="billNumber"
                                    >
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            placeholder="Enter Hospital Bill Number"
                                            min={0}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Date"
                                        name="billDate"
                                    >
                                        <DatePicker
                                            allowClear
                                            style={{ width: "100%" }}
                                            showTime
                                            format={dateFormat}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Hospital Bill Amount"
                                        name="billAmount"
                                    >
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            placeholder="Enter Hospital Bill Amount"
                                            min={0}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Panel>
                </Collapse>

                <Divider orientation="left">Supporting Documents</Divider>

                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "2%",
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#008B8B",
                                color: "#fff",
                                boxShadow: "0px 2px 8px 0px #00000040",
                                marginTop: "10px",
                            }}
                            onClick={props?.handleModalOpen}
                        >
                            Upload document
                        </Button>
                    </div>
                    {
                        // props?.uploadedFileList.length > 0 &&
                        <div className="tableOfPreAuth">
                            <Card style={{ margin: "20px 30px" }}>
                                <Table
                                    dataSource={props?.uploadedHospitalFileList || []}
                                    columns={props?.uploadedFileColumns}
                                    pagination={false}
                                    bordered
                                    style={{
                                        // width: "95%",
                                        // margin: "10px auto",
                                        textAlign: "center",
                                    }}
                                />
                            </Card>
                        </div>}
                </div>
            </>
        )
    }

    const renderOthers = () => {
        return (
            <>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "2%",
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#008B8B",
                                color: "#fff",
                                boxShadow: "0px 2px 8px 0px #00000040",
                                marginTop: "10px",
                            }}
                            onClick={props?.handleModalOpen}
                        >
                            Upload document
                        </Button>
                    </div>
                    {/* <Row>
                                    <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
                                        <Form.Item
                                            // name="documentType"
                                            noStyle
                                        >
                                            <Select
                                                placeholder="Select Document Type"
                                                style={{ width: 200 }}
                                                onChange={(value) => props?.setSelectedDocumentType(value)}
                                            >
                                                <Option value={28}>CLINICAL NOTES</Option>
                                            </Select>
                                        </Form.Item>
            
                                        <Upload
                                            beforeUpload={() => false}
                                            maxCount={1}
                                            onChange={(info) =>
                                                props?.handleUploadFile && props?.handleUploadFile(props?.selectedDocumentType)(info)
                                            }
                                            showUploadList={false}
                                        >
                                            <Button
                                                type="primary"
                                                icon={<UploadOutlined />}
                                                style={{
                                                    backgroundColor: "#008B8B",
                                                    color: "#fff",
                                                    boxShadow: "0px 2px 8px 0px #00000040",
                                                }}
                                                disabled={!props?.selectedDocumentType}
                                            >
                                                Upload Document
                                            </Button>
                                        </Upload>
                                    </Col>
                                </Row> */}
                    {
                        // props?.uploadedFileList.length > 0 &&
                        <div className="tableOfPreAuth">
                            <Card style={{ margin: "20px 30px" }}>
                                <Table
                                    dataSource={props?.uploadedOtherFileList || []}
                                    columns={props?.uploadedFileColumns}
                                    pagination={false}
                                    bordered
                                    style={{
                                        // width: "95%",
                                        // margin: "10px auto",
                                        textAlign: "center",
                                    }}
                                />
                            </Card>
                        </div>}
                </div>
            </>
        )
    }

    return (
        <div style={{ padding: "20px", marginTop: "20px" }}>
            <Card
                className="preAuthCard"
                style={{
                    maxWidth: "100%",
                    margin: "auto",
                    overflow: "hidden",
                    padding: 0,
                    backgroundColor: "#FBFBFB",
                    boxShadow: "0px -1px 4px 0px #00000040 inset",
                }}
            >
                <Steps
                    current={props?.activeStep}
                    style={{
                        marginBottom: 10,
                        backgroundColor: "#E5F3F3",
                        padding: "20px 25px",
                        boxShadow: "0px -1px 4px 0px #00000040 inset",
                        borderBottom: "none",
                    }}
                >
                    <Step title="FINANCE" />
                </Steps>
                <div style={styles.editAndSaveButtonDesign}>
                    <Space>
                        {(props?.stageStatus !== 4 && activeFinanceTab.id === 1) && caseClaimId ? (
                            !disabledForm ? (
                                <Button
                                    // type="primary"
                                    style={styles.saveEditButton}
                                    icon={<SaveOutlined />}
                                    onClick={handleUpdateAsDraftToPortal}

                                // disabled={!isFormValid}
                                >
                                    Save
                                </Button>
                            ) : (
                                <Button
                                    style={styles.editButton}
                                    icon={<EditOutlined />}
                                    onClick={() => setDisabledForm(false)}
                                >
                                    Edit
                                </Button>
                            )
                        ) : (
                            <></>
                        )}
                    </Space>
                </div>
                {props?.activeStep === 0 && (
                    <div style={{ padding: "15px 0" }}>
                        <div style={{ display: "flex", padding: "0 55px", marginTop: "10px" }}>
                            {financeTabs.map((tab) => (
                                <Button
                                    key={tab.id}
                                    type={activeFinanceTab.id === tab.id ? "primary" : "default"}
                                    onClick={() => setActiveFinanceTab(tab)}
                                    style={getTabButtonStyle(activeFinanceTab.id === tab.id)}
                                >
                                    {tab.label}
                                </Button>
                            ))}
                        </div>
                        <div style={{ padding: "15px", border: "1px solid #f0f0f0", margin: "0 55px" }}>
                            <div
                                hidden={!(activeFinanceTab.id === 0)}
                            >
                                {renderAmountIncentive()}
                            </div>
                            <div
                                hidden={!(activeFinanceTab.id === 1)}
                            >
                                {renderHospitalForm()}
                            </div>
                            <div
                                hidden={!(activeFinanceTab.id === 2)}
                            >
                                {renderOthers()}
                            </div>
                        </div>
                    </div>
                )}

                <div
                    style={{
                        marginTop: 20,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "30px",
                        borderTop: "1px solid #D9D9D9",
                        padding: "15px 20px",
                    }}
                >
                    {props?.activeStep !== 0 &&
                        <Button
                            disabled={props?.activeStep === 0}
                            style={{
                                border: "none",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                color: "#575757",
                                fontWeight: "bold",
                            }}
                            onClick={props?.handlePrevious}
                        >
                            &lt; PREVIOUS
                        </Button>}
                    {props?.activeStep !== 0 && (
                        <div style={{ width: "18%" }}>
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: "#008B8B",
                                    color: "#fff",
                                    boxShadow: "0px 2px 8px 0px #00000040",
                                    width: "100%",
                                }}
                                onClick={props?.handleNext}
                            >
                                SAVE AND CONTINUE
                            </Button>
                        </div>
                    )}
                    {props?.activeStep === 0 && (
                        <>
                            {
                                (props?.stageStatus !== 4 && props?.stageStatus !== 2) &&
                                (<div style={{ width: "16%" }}>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: "#008B8B",
                                            color: "#fff",
                                            boxShadow: "0px 2px 8px 0px #00000040",
                                            width: "100%",
                                        }}
                                        onClick={caseClaimId ? handleUpdateAsDraftToPortal : handleSaveAsDraftToPortal}
                                    >
                                        {caseClaimId ? "UPDATE AS DRAFT" : "SAVE AS DRAFT"}
                                    </Button>
                                </div>)
                            }
                            {
                                (props?.stageStatus !== 4 && props?.stageStatus !== 2) &&
                                (<div style={{ width: "16%" }}>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: "#008B8B",
                                            color: "#fff",
                                            boxShadow: "0px 2px 8px 0px #00000040",
                                            width: "100%",
                                        }}
                                        onClick={handleSubmitToPortal}
                                    >
                                        SUBMIT TO PORTAL
                                    </Button>
                                </div>)
                            }
                        </>
                    )}
                </div>
            </Card>
        </div>
    );
};